import {createType, createAction} from 'store/utils';

const prefix = 'LAST_RECALC_DATE_TIME';

export const UPDATE_LAST_RECALC = createType(prefix, 'UPDATE');
export const updateLastRecalc = (payload: LastRecalcDateTimeState): Action =>
  createAction(UPDATE_LAST_RECALC, payload);
